import Axios from 'axios'

import { env } from '@/src/config/env'
import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'

import { setAppTypeInterceptor, setNetworkErrorInterceptor, setVersionInterceptor } from './interceptors'

import type { TLocale } from '@/translations/translations.types'

if (env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const MockAdapter = require('axios-mock-adapter')
  ;(window as Window & { mock?: unknown }).mock = new MockAdapter(Axios, {
    onNoMatch: 'passthrough',
    delayResponse: 500,
  })
}

export const axiosInstance = Axios.create({
  baseURL: env.EXPO_PUBLIC_APP_BASE_URL + '/fr',
})

// When the user is not loggedIn, the app uses the cached version of the base URL
// BASE_URL looks like this : https://preprod.hozana.org/api
// We just add "-cache" at the end of the base URL : https://preprod.hozana.org/api-cache
const getCachedBaseUrl = (locale: TLocale) => `${env.EXPO_PUBLIC_APP_BASE_URL}-cache/${locale}`

export const getBaseUrl = (locale: TLocale) => `${env.EXPO_PUBLIC_APP_BASE_URL}/${locale}`

/**
 * Sets the base URL of the Axios instance based on the provided locale and login status.
 * If is the user is logged in, the base URL will be the cached one.
 * @param {TLocale} locale - The locale to set in the base URL.
 * @param {boolean} isLoggedIn - Indicates whether the user is logged in, affecting the URL.
 */
export const setAxiosInstanceLocale = (locale: TLocale) => {
  axiosInstance.defaults.baseURL = getIsLoggedIn() ? getBaseUrl(locale) : getCachedBaseUrl(locale)
}

// Add interceptors
setNetworkErrorInterceptor(axiosInstance)
setVersionInterceptor(axiosInstance)
setAppTypeInterceptor(axiosInstance)
